export default __webpack_public_path__ + "static/media/rounded-bottom-3.567e4adc.webp";